import { render, staticRenderFns } from "./Locator.vue?vue&type=template&id=f6104770&scoped=true&"
import script from "./Locator.vue?vue&type=script&lang=js&"
export * from "./Locator.vue?vue&type=script&lang=js&"
import style0 from "./Locator.vue?vue&type=style&index=0&id=f6104770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6104770",
  null
  
)

export default component.exports